import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';

const FOOTER_LINKS = [
  { label: 'תנאי שימוש',      path: '/terms' },
  { label: 'מדיניות פרטיות',  path: '/privacy' },
  { label: 'צור קשר',         path: '/contact' },
];

const FinalCTASection = ({ onOpenModal }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: '#1e3a5f', position: 'relative', overflow: 'hidden' }}>
      {/* Gold radial glow */}
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        width: '700px',
        height: '400px',
        borderRadius: '50%',
        background: 'radial-gradient(ellipse, rgba(154,114,9,0.18) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      {/* Main CTA */}
      <Box sx={{
        py: { xs: 12, md: 16 },
        px: { xs: 3, md: 6 },
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
        maxWidth: '700px',
        mx: 'auto',
      }}>
        <Typography dir="rtl" sx={{
          fontFamily: 'Frank Ruhl Libre, serif',
          color: 'white',
          fontSize: { xs: '2.1rem', md: '3rem' },
          fontWeight: 900,
          letterSpacing: '-0.02em',
          lineHeight: 1.25,
          mb: 3,
          direction: 'rtl',
        }}>
          מוכן{' '}
          <Box component="span" className="lp-gold-text">להאיר</Box>
          {' '}את בית הכנסת שלך?
        </Typography>

        <Typography sx={{
          color: 'rgba(255,255,255,0.6)',
          fontFamily: 'Heebo, sans-serif',
          fontSize: { xs: '1rem', md: '1.15rem' },
          lineHeight: 1.8,
          mb: 5,
          maxWidth: '480px',
          mx: 'auto',
        }}>
          14 יום חינם — ללא כרטיס אשראי.
          ראה בעצמך מה inorai יכולה לעשות לקהילה שלך.
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/login')}
          sx={{
            bgcolor: '#9a7209',
            color: 'white',
            fontFamily: 'Heebo, sans-serif',
            fontWeight: 700,
            fontSize: '1.15rem',
            px: 6,
            py: 2,
            borderRadius: 3,
            boxShadow: '0 10px 40px rgba(154,114,9,0.5)',
            '&:hover': {
              bgcolor: '#b8860b',
              transform: 'translateY(-3px)',
              boxShadow: '0 16px 48px rgba(154,114,9,0.6)',
            },
            transition: 'all 0.25s ease',
          }}
        >
          התחל חינם — 14 יום
        </Button>

        <Typography sx={{
          color: 'rgba(255,255,255,0.3)',
          fontFamily: 'Heebo, sans-serif',
          fontSize: '0.85rem',
          mt: 2,
        }}>
          ללא כרטיס אשראי · ניתן לבטל בכל עת
        </Typography>
      </Box>

      {/* Footer */}
      <Box sx={{
        borderTop: '1px solid rgba(255,255,255,0.08)',
        py: 4,
        px: { xs: 3, md: 6 },
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        position: 'relative',
        zIndex: 1,
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box component="img"
            src="/inorai-logo.png"
            alt="inorai logo"
            sx={{ width: 28, height: 28, objectFit: 'contain' }}
          />
          <Typography sx={{
            fontFamily: 'Secular One, sans-serif',
            color: 'rgba(255,255,255,0.6)',
            fontSize: '1rem',
          }}>
            inorai
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          {FOOTER_LINKS.map(({ label, path }) => (
            <Typography
              key={label}
              onClick={() => {
                if (label === 'צור קשר') onOpenModal?.('contact');
                else if (label === 'תנאי שימוש') onOpenModal?.('terms');
                else if (label === 'מדיניות פרטיות') onOpenModal?.('privacy');
                else navigate(path);
              }}
              sx={{
                color: 'rgba(255,255,255,0.35)',
                fontFamily: 'Heebo, sans-serif',
                fontSize: '0.82rem',
                textDecoration: 'none',
                '&:hover': { color: 'rgba(255,255,255,0.65)' },
                transition: 'color 0.2s ease',
                cursor: 'pointer',
              }}
            >
              {label}
            </Typography>
          ))}
          <Typography
            component="a"
            href="tel:0548467831"
            sx={{
              color: 'rgba(255,255,255,0.35)',
              fontFamily: 'Heebo, sans-serif',
              fontSize: '0.82rem',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              direction: 'ltr',
              '&:hover': { color: 'rgba(255,255,255,0.65)' },
              transition: 'color 0.2s ease',
            }}
          >
            <PhoneIcon sx={{ fontSize: '0.9rem' }} />
            054-846-7831
          </Typography>
        </Box>

        <Typography sx={{
          color: 'rgba(255,255,255,0.25)',
          fontFamily: 'Heebo, sans-serif',
          fontSize: '0.8rem',
        }}>
          © 2025 inorai
        </Typography>
      </Box>
    </Box>
  );
};

export default FinalCTASection;
